<template>
  <component
    :is="semGrupo ? 'div' : FormField"
    v-bind="formFieldProps"
  >
    <div
      class="editor-wrapper"
      :class="{ 'editor-disabled': disabled }"
      :style="{ '--editor-min-height': editorMinHeight }"
      @click="focarEditor"
    >
      <div
        class="editor-toolbar"
        @click.stop
      >
        <button
          type="button"
          class="toolbar-btn"
          title="Negrito (Ctrl+B)"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive('bold') }"
          @click="editor?.chain().focus().toggleBold().run()"
        >
          <strong>B</strong>
        </button>

        <button
          type="button"
          class="toolbar-btn italic-btn"
          title="Itálico (Ctrl+I)"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive('italic') }"
          @click="editor?.chain().focus().toggleItalic().run()"
        >
          <em>I</em>
        </button>

        <button
          type="button"
          class="toolbar-btn underline-btn"
          title="Sublinhado (Ctrl+U)"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive('underline') }"
          @click="editor?.chain().focus().toggleUnderline().run()"
        >
          <u>U</u>
        </button>

        <div class="toolbar-divider"></div>

        <button
          type="button"
          class="toolbar-btn"
          title="Alinhar à esquerda"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive({ textAlign: 'left' }) }"
          @click="editor?.chain().focus().setTextAlign('left').run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M3 4h18v2H3V4zm0 5h12v2H3V9zm0 5h18v2H3v-2zm0 5h12v2H3v-2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="toolbar-btn"
          title="Centralizar"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive({ textAlign: 'center' }) }"
          @click="editor?.chain().focus().setTextAlign('center').run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M3 4h18v2H3V4zm3 5h12v2H6V9zm-3 5h18v2H3v-2zm3 5h12v2H6v-2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="toolbar-btn"
          title="Alinhar à direita"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive({ textAlign: 'right' }) }"
          @click="editor?.chain().focus().setTextAlign('right').run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M3 4h18v2H3V4zm6 5h12v2H9V9zm-6 5h18v2H3v-2zm6 5h12v2H9v-2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="toolbar-btn"
          title="Justificar"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive({ textAlign: 'justify' }) }"
          @click="editor?.chain().focus().setTextAlign('justify').run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M3 4h18v2H3V4zm0 5h18v2H3V9zm0 5h18v2H3v-2zm0 5h18v2H3v-2z"
            />
          </svg>
        </button>

        <div class="toolbar-divider"></div>

        <button
          type="button"
          class="toolbar-btn"
          title="Lista com marcadores"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive('bulletList') }"
          @click="editor?.chain().focus().toggleBulletList().run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M4 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6-13h11v2H10V7zm0 7h11v2H10v-2zm0 7h11v2H10v-2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="toolbar-btn"
          title="Lista numerada"
          :disabled="disabled || !editor"
          :class="{ 'is-active': editor?.isActive('orderedList') }"
          @click="editor?.chain().focus().toggleOrderedList().run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M2 4h3v1.5H3.5V7H5v1.5H2V7h1.5V5.5H2V4zm0 7h3.5v1H3.2l1.8 1.8V15H2v-1h1.8L2 12.2V11zm0 7h3.5v3H2v-1h2v-.5H3v-1h1V19H2v-1zm6-13h13v2H8V5zm0 7h13v2H8v-2zm0 7h13v2H8v-2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="toolbar-btn"
          title="Desfazer (Ctrl+Z)"
          :disabled="disabled || !editor || !editor.can().undo()"
          @click="editor?.chain().focus().undo().run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12.5 8c-2.65 0-5.05 1-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="toolbar-btn"
          title="Refazer (Ctrl+Y)"
          :disabled="disabled || !editor || !editor.can().redo()"
          @click="editor?.chain().focus().redo().run()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M18.4 10.6C16.55 9 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
            />
          </svg>
        </button>
      </div>

      <editor-content
        :editor="editor"
        class="editor-content"
      />
    </div>
  </component>
</template>

<script setup>
import { computed, watch, onBeforeUnmount } from "vue";
import { useEditor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import FormField from "@/components/common/FormField.vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  helpText: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  rows: {
    type: [Number, String],
    default: 8,
  },
  groupClass: {
    type: [String, Object, Array],
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  semGrupo: {
    type: Boolean,
    default: false,
  },
});

const model = defineModel({ default: "" });

const editorMinHeight = computed(() => {
  const numRows = Number(props.rows) || 8;
  return `calc(${numRows * 1.6}em + 24px)`;
});

function converterParaHtml(conteudo) {
  if (!conteudo) return "";
  if (typeof conteudo !== "string") return String(conteudo);
  // Se já contém tags HTML como <p>, <br>, <div>, retorna diretamente
  if (/<[a-z][\s\S]*>/i.test(conteudo)) {
    return conteudo;
  }
  // Se for texto plano com quebras de linha (\n), converte para <p> e <br>
  const blocos = conteudo.split(/\r?\n\r?\n+/);
  return blocos
    .map((bloco) => {
      const linhas = bloco.split(/\r?\n/).join("<br>");
      return `<p>${linhas || "<br>"}</p>`;
    })
    .join("");
}

const editor = useEditor({
  content: converterParaHtml(model.value),
  editable: !props.disabled,
  extensions: [
    StarterKit.configure({
      hardBreak: {
        keepMarks: true,
      },
    }),
    Underline,
    TextAlign.configure({
      types: ["heading", "paragraph"],
    }),
  ],
  onUpdate: ({ editor }) => {
    const html = editor.getHTML();
    model.value = editor.isEmpty || html === "<p></p>" ? "" : html;
  },
});

const formFieldProps = computed(() => {
  if (props.semGrupo) return {};
  return {
    label: props.label,
    id: props.id,
    required: props.required,
    helpText: props.helpText,
    errorMessage: props.errorMessage,
    groupClass: props.groupClass,
  };
});

function focarEditor() {
  if (editor.value && !props.disabled) {
    editor.value.commands.focus();
  }
}

watch(
  () => model.value,
  (novoValor) => {
    if (!editor.value) return;
    const conteudoAtual = editor.value.getHTML();
    const novoHtml = converterParaHtml(novoValor);

    const isSame =
      conteudoAtual === novoValor ||
      conteudoAtual === novoHtml ||
      (editor.value.isEmpty && (!novoValor || novoValor === "<p></p>"));

    if (!isSame) {
      editor.value.commands.setContent(novoHtml, false);
    }
  }
);

watch(
  () => props.disabled,
  (isDisabled) => {
    if (editor.value) {
      editor.value.setEditable(!isDisabled);
    }
  }
);

onBeforeUnmount(() => {
  if (editor.value) {
    editor.value.destroy();
  }
});
</script>

<style scoped>
:deep(.field-group.full-height) {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.editor-wrapper {
  border: 1px solid var(--roxo-claro);
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: calc(var(--editor-min-height, 230px) + 42px);
  background-color: var(--branco, var(--branco));
  cursor: text;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.editor-wrapper:focus-within {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 2px hsla(258, 46%, 46%, 0.12);
}

.editor-disabled {
  opacity: 0.6;
  background-color: var(--branco);
  cursor: not-allowed;
  pointer-events: none;
}

.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 6px 10px;
  background: var(--roxo-superficie);
  border-bottom: 1px solid var(--cinza-claro);
  flex-wrap: wrap;
  cursor: default;
}

.toolbar-btn {
  background: transparent;
  border: 1px solid transparent;
  padding: 4px 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--preto, var(--cinza-escuro));
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
}

.toolbar-btn:hover:not(:disabled) {
  background: var(--roxo-superficie);
  color: var(--roxo-medio);
  border-color: var(--roxo-claro);
}

.toolbar-btn.is-active {
  background: var(--roxo-medio);
  color: var(--branco);
  border-color: var(--roxo-medio);
}

.toolbar-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.toolbar-divider {
  width: 1px;
  height: 20px;
  background: var(--cinza-claro);
  margin: 0 4px;
}

:deep(.editor-content) {
  flex: 1;
  display: flex;
  flex-direction: column;
}

:deep(.editor-content .tiptap) {
  flex: 1;
  min-height: var(--editor-min-height, 230px);
  padding: 12px;
  outline: none;
  font-size: 0.9rem;
  font-family: inherit;
  color: var(--preto, var(--cinza-escuro));
  line-height: 1.6;
  box-sizing: border-box;
}

:deep(.editor-content .tiptap p) {
  margin: 0 0 0.8em 0;
}

:deep(.editor-content .tiptap p:last-child) {
  margin-bottom: 0;
}

:deep(.editor-content .tiptap ul),
:deep(.editor-content .tiptap ol) {
  padding-left: 1.5rem;
  margin: 0 0 0.8em 0;
}

:deep(.editor-content .tiptap li) {
  margin-bottom: 0.3em;
}

:deep(.editor-content .tiptap blockquote) {
  border-left: 3px solid var(--roxo-medio);
  padding-left: 1rem;
  margin: 0.8em 0;
  color: var(--cinza-escuro);
}
</style>
